module.exports = __webpack_public_path__ + "assets/e7c4a1fc98bafc889f40e16140bd7def.png";